import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import {
	Grid,
	ListItem,
	ListItemText,
	TextField,
	Typography,
	Box
} from '@mui/material'

import i18next, { t } from 'i18next'
import numeral from 'numeral'

const sx = {
	primary: {
		display: 'flex',
		alignItems: 'flex-start',
		marginBottom: (theme) => theme.spacing()
	},
	bold: {
		fontWeight: 500
	}
}

class Material extends PureComponent {
	static propTypes = {
		material: PropTypes.object.isRequired
	}

	render() {
		const { material } = this.props

		const primaryText = (
			<Box sx={sx.primary}>
				<Typography variant="body2">
					<span sx={sx.bold}>{material.descriptions[i18next.language]}</span>
				</Typography>
			</Box>
		)

		let unit = material.unit
		if (material.unitDescriptions) {
			unit = material.unitDescriptions.short[i18next.language]
		}

		const materialDetails = (
			<Fragment>
				<Grid container spacing={1}>
					<Grid item sm={4} xs={12}>
						<TextField
							multiline
							fullWidth
							label={t('app:CallOffs.Deliveries.articleNumber')}
							value={material.materialNumber}
							InputProps={{
								readOnly: true,
								disableUnderline: true
							}}
							variant="standard"
						/>
					</Grid>
					<Grid item sm={4} xs={12}>
						<TextField
							multiline
							fullWidth
							label={t('app:CallOffs.Deliveries.called')}
							value={`${numeral(material.quantityCalledOff).format(
								0,
								0
							)} ${unit}`}
							InputProps={{
								readOnly: true,
								disableUnderline: true
							}}
							variant="standard"
						/>
					</Grid>
					<Grid item sm={4} xs={12}>
						<TextField
							multiline
							fullWidth
							label={t('app:CallOffs.Deliveries.deliveryQuantity')}
							value={`${numeral(material.quantityDelivered).format(
								0,
								0
							)} ${unit}`}
							InputProps={{
								readOnly: true,
								disableUnderline: true
							}}
							variant="standard"
						/>
					</Grid>
				</Grid>
			</Fragment>
		)

		return (
			<ListItem>
				<ListItemText
					inset
					disableTypography
					primary={primaryText}
					secondary={materialDetails}
				/>
			</ListItem>
		)
	}
}

export default Material
